import { render } from "./MblElcSignaturePad.vue?vue&type=template&id=635fc866&scoped=true"
import script from "./MblElcSignaturePad.vue?vue&type=script&lang=js"
export * from "./MblElcSignaturePad.vue?vue&type=script&lang=js"

import "./MblElcSignaturePad.vue?vue&type=style&index=0&id=635fc866&scoped=true&lang=css"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635fc866"]])

export default __exports__